import React,{useState,useEffect,useRef} from "react";
import {
    IonContent,
    IonIcon,
    IonButton,
    IonModal,
    IonToolbar,
    IonButtons,
    IonHeader, IonFooter
} from "@ionic/react";
import {arrowBack, funnel, funnelOutline} from "ionicons/icons";
import MatrimonialFilterSheetModal from "../components/MatrimonialFilterSheetModal";
import useStore from "../zustand/useStore";
import {FacebookLoader} from "./Loader/FacebookLoader";
import NoDataFoundOrSelectedDiv from "./NoDataFoundOrSelectedDiv";
import {actionToGetMatrimonialPostingByFilter} from "../apiHelpers/CommonAction";
import MatrimonyProfileCard from "./MatrimonyProfileCard";

export default function MatrimonialRoleBasedDataMobile({isOpen,onDidDismiss}) {
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const {matrimonialPostingState,selectedReligion,selectedAge,
        setMatrimonialProfileDetail,setIsMatrimonialDetailOpen,
        selectedEducation,selectedLocation,selectedMeritialStatus,selectedHeight,selectedManglikStatus} = useStore();
    const {loading,profiles,totalCount} = matrimonialPostingState;
    const isFetchingRef = useRef(false);
    const observerRef = React.useRef(null);
    const [filterTypeSelection,setFilterTypeSelection] = useState('Religion');

    const callFunctionToFilterMatrimonialPosting = async (isLoad = true) => {
        if (isFetchingRef.current) return;
            isFetchingRef.current = true;

        const payload = {};

        // Add matrimonial filters to payload
        if (selectedReligion.length > 0) payload.selectedReligion = selectedReligion;
        if (selectedAge > 0) payload.selectedAge = selectedAge;
        if (selectedEducation) payload.selectedEducation = selectedEducation;
        if (selectedLocation.length > 0) payload.selectedLocation = selectedLocation;
        if (selectedMeritialStatus.length > 0) payload.selectedMeritialStatus = selectedMeritialStatus;
        if (selectedHeight > 0) payload.selectedHeight = selectedHeight;
        if (selectedManglikStatus) payload.selectedManglikStatus = selectedManglikStatus;
        payload.me_mode = false;

        // Optional: pass limit/offset or pagination if needed
        payload.limit = 10;
        payload.offset = matrimonialPostingState.offset || 0;

        await actionToGetMatrimonialPostingByFilter(isLoad, payload);

        isFetchingRef.current = false;
    };


    useEffect(() => {
        if(isOpen) {
            callFunctionToFilterMatrimonialPosting();
        }
    },[isOpen])

    const openMatrimonialProfileDetailPanel = (detail)=>{
        setMatrimonialProfileDetail(detail);
        setIsMatrimonialDetailOpen(true);
    }

    const lastJobElementRef = React.useCallback(
        (node) => {
            if (observerRef.current) observerRef.current.disconnect();

            observerRef.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && profiles?.length < totalCount) {
                    callFunctionToFilterMatrimonialPosting(false); // Load next page
                }
            });

            if (node) observerRef.current.observe(node);
        },
        [totalCount,profiles, callFunctionToFilterMatrimonialPosting]
    );

    const callFunctionToSetIsFilterOpen = (type)=>{
        setFilterTypeSelection(type);
        setIsFilterOpen(true);
    }

    const showApplyButton =
        selectedReligion.length > 0 ||
        selectedAge > 0 ||
        selectedEducation.length > 0 ||
        selectedLocation.length > 0 ||
        selectedMeritialStatus.length > 0 ||
        selectedHeight > 0 ||
        selectedManglikStatus.length > 0

    const panelSubHeader = ()=>{
        return (
            <div className={`filter-header-wrapper`}>
                <div className="filter-header">
                    <IonButton fill="clear" size="small" onClick={() => callFunctionToSetIsFilterOpen('Religion')}
                               className={`filter-btn ${showApplyButton ? 'active' : ''}`}>
                        {(showApplyButton) ?
                            <IonIcon icon={funnel} slot="start"/>
                            :
                            <IonIcon icon={funnelOutline} slot="start"/>
                        }
                    </IonButton>
                    <div className="tags">
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Religion' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Religion')}>Religion</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Education' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Education')}>Education</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Location' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Location')}>Location</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Marital Status' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Marital Status')}>Marital Status</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Manglik Status' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Manglik Status')}>Manglik Status</span>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onDidDismiss}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <div className="job_detail_sheet_header_text">
                        <div className="job-basic-info-image">
                            <span className="job-basic-info-text">
                                Matrimonial Posts List
                            </span>
                        </div>
                    </div>
                </IonToolbar>
                <IonToolbar>
                    {panelSubHeader()}
                </IonToolbar>
            </IonHeader>
            <IonContent className="mobile-job-list-page page-content">

                {(loading) ?
                    <div className="job-list">
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                    </div>
                    :
                    (profiles && profiles?.length > 0) ?
                        <div className="job-list">
                            {profiles.map((profile, index) => {
                                if (index === profiles.length - 1) {
                                    return (
                                        <div ref={lastJobElementRef} key={profile.id}>
                                            <MatrimonyProfileCard
                                                profile={profile}
                                                key={profile.id}
                                                handleProfileItemClick={openMatrimonialProfileDetailPanel}
                                            />
                                        </div>
                                    );
                                }
                                return (
                                    <MatrimonyProfileCard
                                        profile={profile}
                                        key={profile.id}
                                        handleProfileItemClick={openMatrimonialProfileDetailPanel}
                                    />
                                );
                            })}
                        </div>
                        :
                        <div className="job-list">
                            <NoDataFoundOrSelectedDiv/>
                        </div>
                }
            </IonContent>
            <IonFooter className={"blank_footer_bar"}>
                <IonToolbar>

                </IonToolbar>
            </IonFooter>
            {(isFilterOpen) ?
            <MatrimonialFilterSheetModal
                isOpen={isFilterOpen}
                filterTypeSelection={filterTypeSelection}
                setFilterTypeSelection={setFilterTypeSelection}
                onDidDismiss={() => setIsFilterOpen(false)}
            />:''
            }
        </IonModal>
    );
}
